/* eslint-disable max-len */
import {
	chakra,
	forwardRef,
	IconProps as ChakraIconProps,
} from "@chakra-ui/react";
import React, { RefAttributes } from "react";

export type Prettify<T> = {
	[K in keyof T]: T[K];
} & {};

export type IconProps = Prettify<
	ChakraIconProps & RefAttributes<SVGSVGElement>
>;

export const Ellipsis = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#7a7a7a"
			d="M4.5 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
		/>
	</chakra.svg>
));

export const Section = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			d="M4 2a2 2 0 00-2 2v3a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm16 5H4V4h16zM2 12v8a2 2 0 002 2h16a2 2 0 002-2v-8a2 2 0 00-2-2H4a2 2 0 00-2 2zm18 0v8H4v-8zm-9 5H9v-2h2v-2h2v2h2v2h-2v2h-2z"
			fill="#690aa0"
		/>
	</chakra.svg>
));

export const Heading = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			d="m17 19v-14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v6h-6v-6a1 1 0 0 0-1-1 0.94 0.94 0 0 0-1 1v14a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-6h6v6a1 1 0 0 0 1 1 0.94 0.94 0 0 0 1-1z"
			fill="#690aa0"
		/>
	</chakra.svg>
));

export const Advertisement = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M10 8a2 2 0 0 0-2 2v27.172l4.586-4.586A2 2 0 0 1 14 32h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H10ZM5.757 5.757A6 6 0 0 1 10 4h28a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H14.828l-7.414 7.414A2 2 0 0 1 4 42V10a6 6 0 0 1 1.757-4.243Z"
			clipRule="evenodd"
		/>
		<path
			fill="#690aa0"
			d="M25.05 26V14.257h3.926c1.365 0 2.489.246 3.372.738.895.481 1.555 1.164 1.98 2.047.436.872.654 1.901.654 3.087 0 1.185-.218 2.22-.654 3.103-.425.872-1.08 1.555-1.963 2.047-.884.48-2.013.721-3.389.721h-3.925Zm2.266-1.946h1.543c.962 0 1.717-.156 2.265-.47a2.63 2.63 0 0 0 1.19-1.342c.236-.592.353-1.297.353-2.113 0-.828-.117-1.533-.352-2.114a2.622 2.622 0 0 0-1.191-1.359c-.548-.313-1.303-.47-2.265-.47h-1.543v7.868ZM12.37 26l4.293-11.743h2.567L23.508 26h-2.399l-3.17-9.16L14.75 26H12.37Zm1.895-2.667.604-1.762h5.972l.587 1.762h-7.163Z"
		/>
	</chakra.svg>
));

export const BannerPosts = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 8a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm14 0H8v32h10V8Zm8 0a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V8Zm14 0H30v10h10V8ZM26 30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V30Zm14 0H30v10h10V30Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const CategoryList = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 8a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm14 0H8v10h10V8Zm8 0a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V8Zm14 0H30v10h10V8ZM4 30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V30Zm14 0H8v10h10V30Zm17 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 4a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Archive = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 48 48"
		{...props}
	>
		<path
			fill="#690aa0"
			d="m20 12 .204.01a2 2 0 0 1 0 3.98L20 16H4a2 2 0 1 1 0-4h16Zm12 22V16a2 2 0 1 1 4 0v18a2 2 0 1 1-4 0Z"
		/>
		<path
			fill="#690aa0"
			d="M10 34V16a2 2 0 1 1 4 0v18a2 2 0 1 1-4 0Zm30.737-9.552a2 2 0 0 1 2.815 2.815l-.138.151-8 8a2 2 0 0 1-2.677.138l-.151-.138-8-8-.138-.151a2 2 0 0 1 2.815-2.815l.151.138L34 31.172l6.586-6.586.151-.138Z"
		/>
	</chakra.svg>
));

export const Breadcrumbs = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M6.43 9.233a.72.72 0 0 0-1.003 1.034L7.215 12l-1.788 1.733a.72.72 0 1 0 1.003 1.034l2.321-2.25a.72.72 0 0 0 0-1.034L6.43 9.233Zm4.821 0a.72.72 0 0 0-1.002 1.034L12.037 12l-1.788 1.733a.72.72 0 0 0 1.002 1.034l2.322-2.25a.72.72 0 0 0 0-1.034l-2.322-2.25Zm4.822 0a.72.72 0 0 0-1.003 1.034L16.858 12l-1.788 1.733a.72.72 0 1 0 1.003 1.034l2.32-2.25a.72.72 0 0 0 0-1.034l-2.32-2.25Z"
		/>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M2 6.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-11Zm2 0h16v11H4v-11Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const PostTitle = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 48 48"
		{...props}
		h={6}
		w={6}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M18.9 35.5a1.7 1.7 0 0 1-1.7-1.7V17.2h-4.4a1.6 1.6 0 1 1 0-3.2H25a1.6 1.6 0 1 1 0 3.2h-4.4v16.6a1.7 1.7 0 0 1-1.7 1.7Zm15.5.5c-1.466 0-2.616-.425-3.45-1.275-.833-.85-1.25-2.025-1.25-3.525v-8.1h-1.25a1.45 1.45 0 0 1 0-2.9h1.25v-2.7a1.65 1.65 0 1 1 3.3 0v2.7h2.25a1.45 1.45 0 0 1 0 2.9H33v7.4c0 .767.175 1.367.525 1.8.35.433.825.65 1.425.65.3 0 .608-.058.925-.175.418-.154.925.122.925.567v1.4c0 .495-.276.965-.756 1.086a4.282 4.282 0 0 1-.344.072c-.4.067-.833.1-1.3.1Z"
		/>
	</chakra.svg>
));

export const Category = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M24 37.5a1.5 1.5 0 0 1 0 3H6a1.5 1.5 0 0 1 0-3h18Zm18-7a1.5 1.5 0 0 1 0 3H6a1.5 1.5 0 0 1 0-3h36Z"
		/>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 12a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V12Zm14 0H8v10h10V12Zm17 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 4a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const DateWeather = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M24 2a2 2 0 0 1 2 2v4a2 2 0 1 1-4 0V4a2 2 0 0 1 2-2ZM8.446 8.446a2 2 0 0 1 2.829 0l2.82 2.82a2 2 0 0 1-2.829 2.828l-2.82-2.82a2 2 0 0 1 0-2.828ZM38 24a2 2 0 0 1 2-2h4a2 2 0 1 1 0 4h-4a2 2 0 0 1-2-2Zm1.554-15.554a2 2 0 0 1 0 2.828l-2.82 2.82a2 2 0 1 1-2.828-2.828l2.82-2.82a2 2 0 0 1 2.828 0Zm-20.499 6.86a10.002 10.002 0 0 1 14.812 10.32 2 2 0 1 1-3.946-.652 6 6 0 0 0-8.888-6.192 2 2 0 0 1-1.978-3.476Zm-3.138 10.927A8 8 0 1 0 14 42h12a4 4 0 1 0 0-8h-2.2a2 2 0 0 1-1.96-1.6 8 8 0 0 0-5.923-6.167Zm-5.714-3.616A12 12 0 0 1 25.316 30H26a8 8 0 0 1 0 16H14a12.001 12.001 0 0 1-3.797-23.383Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const FeaturedCategories = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 40a2 2 0 0 1 2-2h9a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2Zm23 0a2 2 0 0 1 2-2h9a2 2 0 1 1 0 4h-9a2 2 0 0 1-2-2ZM4 33a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2Zm23 0a2 2 0 0 1 2-2h13a2 2 0 1 1 0 4H29a2 2 0 0 1-2-2ZM7.244 24.203l-.002-.001ZM7.139 24A2.349 2.349 0 0 1 7 23.167V11.833c0-.363.067-.647.139-.833h10.723c.071.186.138.47.138.833v11.334c0 .363-.067.647-.139.833H7.14Zm10.617.203.002-.001Zm0-13.406.002.001Zm-10.512 0-.001.001Zm-3.48 15.387C3.252 25.314 3 24.242 3 23.167V11.833c0-1.075.252-2.147.764-3.017C4.25 7.992 5.208 7 6.667 7h11.666c1.459 0 2.418.992 2.903 1.816.512.87.764 1.942.764 3.017v11.334c0 1.075-.252 2.147-.764 3.017-.485.824-1.444 1.816-2.903 1.816H6.667c-1.459 0-2.418-.992-2.903-1.816Zm26.48-1.981-.002-.001ZM30.139 24a2.35 2.35 0 0 1-.139-.833V11.833c0-.363.067-.647.139-.833h10.723c.071.186.138.47.138.833v11.334c0 .363-.067.647-.139.833H30.14Zm10.617.203.002-.001Zm0-13.406.002.001Zm-10.512 0-.002.001Zm-3.48 15.387c-.512-.87-.764-1.942-.764-3.017V11.833c0-1.075.252-2.147.764-3.017C27.25 7.992 28.208 7 29.667 7h11.666c1.459 0 2.418.992 2.903 1.816.512.87.764 1.942.764 3.017v11.334c0 1.075-.252 2.147-.764 3.017-.485.824-1.444 1.816-2.903 1.816H29.667c-1.459 0-2.418-.992-2.903-1.816Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const FeaturedImage = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M36.735 4h-25.47C9.306 4 8 5.137 8 6.843v22.172C8 30.721 9.143 32 11.265 32h25.47C38.694 32 40 30.863 40 29.157V6.985C39.837 5.137 38.694 4 36.735 4Zm-25.47 25.015V6.843h25.47v22.172h-25.47Z"
		/>
		<path
			fill="#690aa0"
			d="m20.776 20.776-1.694-1.694L14 25.857h20.327L25.857 14l-5.081 6.776ZM8 36.5A1.5 1.5 0 0 1 9.5 35h27a1.5 1.5 0 0 1 0 3h-27A1.5 1.5 0 0 1 8 36.5Zm0 6A1.5 1.5 0 0 1 9.5 41h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 8 42.5Z"
		/>
	</chakra.svg>
));

export const FeaturedPosts = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M12 44a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H14a2 2 0 0 1-2-2Zm-4-8a2 2 0 0 1 2-2h28a2 2 0 1 1 0 4H10a2 2 0 0 1-2-2Zm0-12a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v16Zm2 6a6 6 0 0 1-6-6V8a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6H10Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const GridModule = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 8a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm14 0H8v10h10V8Zm8 0a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V8Zm14 0H30v10h10V8ZM26 30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V30Zm14 0H30v10h10V30ZM4 30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V30Zm14 0H8v10h10V30Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const NewsTicker = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M13.333 7C11.084 7 10 8.413 10 9.333v30.334c0 .92 1.084 2.333 3.333 2.333h21.334C36.916 42 38 40.587 38 39.667V9.333C38 8.413 36.916 7 34.667 7H13.333ZM6 9.333C6 5.467 9.691 3 13.333 3h21.334C38.309 3 42 5.467 42 9.333v30.334C42 43.532 38.309 46 34.667 46H13.333C9.691 46 6 43.532 6 39.667V9.333Z"
			clipRule="evenodd"
		/>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M26.432 9.564A1.5 1.5 0 0 1 27.5 11v8.885H33a1.5 1.5 0 0 1 1.25 2.328l-11 16.615A1.5 1.5 0 0 1 20.5 38v-8.885H15a1.5 1.5 0 0 1-1.25-2.328l11-16.615a1.5 1.5 0 0 1 1.682-.608Zm-8.64 16.551H22a1.5 1.5 0 0 1 1.5 1.5v5.402l6.708-10.132H26a1.5 1.5 0 0 1-1.5-1.5v-5.402l-6.708 10.132Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const PostList = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M4 8a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm14 0H8v10h10V8ZM4 30a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V30Zm14 0H8v10h10V30Zm8-22a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H28a2 2 0 0 1-2-2Zm0 10a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H28a2 2 0 0 1-2-2Zm0 12a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H28a2 2 0 0 1-2-2Zm0 10a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H28a2 2 0 0 1-2-2Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const PostVideo = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M19.793 20.445a3.5 3.5 0 0 1 3.536.071l7.33 4.499a3.504 3.504 0 0 1 1.668 2.982 3.5 3.5 0 0 1-1.668 2.982l-7.33 4.501A3.5 3.5 0 0 1 18 32.495v-9.001a3.5 3.5 0 0 1 1.793-3.05ZM22 24.394l5.871 3.603L22 31.603v-7.21ZM8 6a2 2 0 0 1 2-2h28a2 2 0 1 1 0 4H10a2 2 0 0 1-2-2Z"
			clipRule="evenodd"
		/>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M9.6 16c-.69 0-1.6.692-1.6 2v20c0 1.308.91 2 1.6 2h28.8c.69 0 1.6-.692 1.6-2V18c0-1.308-.91-2-1.6-2H9.6ZM4 18c0-3.11 2.314-6 5.6-6h28.8c3.286 0 5.6 2.89 5.6 6v20c0 3.11-2.314 6-5.6 6H9.6C6.314 44 4 41.11 4 38V18Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Slider = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M32.4 44H15.6c-2 0-3.6-1.8-3.6-4V8c0-2.2 1.6-4 3.6-4h16.6c2 0 3.6 1.8 3.6 4v32c.2 2.2-1.4 4-3.4 4ZM16 40h16V8H16v32Zm-6-6H8V14h2v-4H7.4c-2 0-3.4 1.4-3.4 3.4v21.4C4 36.6 5.4 38 7.4 38H10v-4Zm28 4h2.6c1.8 0 3.4-1.4 3.4-3.4V13.4c0-2-1.4-3.4-3.4-3.4H38v4h2v20h-2v4Z"
		/>
	</chakra.svg>
));

export const SocialIcons = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			d="M6 15c.9 0 1.7-.3 2.4-.9l6.3 3.6c-.1.3-.1.6-.1.9 0 1.9 1.6 3.5 3.5 3.6 1.9 0 3.5-1.6 3.6-3.5 0-1.9-1.6-3.5-3.5-3.6-.9 0-1.8.3-2.4.9l-6.3-3.6c.1-.2.1-.5.1-.8l6.1-3.5c1.4 1.3 3.6 1.2 4.9-.2s1.2-3.6-.2-4.9-3.6-1.2-4.9.2c-.6.6-.9 1.5-.9 2.4 0 .3 0 .6.1.8L8.9 9.6c-1-1.6-3.2-2.1-4.8-1S2 11.8 3 13.4c.7 1 1.8 1.6 3 1.6zm12 2c.8 0 1.5.7 1.5 1.5S18.8 20 18 20s-1.5-.7-1.5-1.5.6-1.5 1.5-1.5zm0-13c.8 0 1.5.7 1.5 1.5S18.8 7 18 7s-1.5-.7-1.5-1.5S17.1 4 18 4zM6 10c.8 0 1.5.7 1.5 1.5S6.8 13 6 13s-1.5-.7-1.5-1.5S5.1 10 6 10z"
		/>
	</chakra.svg>
));

export const TabPost = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M12 20V8H8v32h32V20H12ZM4 7v34a3 3 0 0 0 3 3h34a3 3 0 0 0 3-3V19a3 3 0 0 0-3-3H16V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3Z"
			clipRule="evenodd"
		/>
		<path
			fill="#690aa0"
			fillRule="evenodd"
			d="M21 7v4h6V7h-6Zm-1-3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-8Zm15 3v4h6V7h-6Zm-1-3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-8Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Button = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			d="m4 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm16 8h-16v-6h16z"
			fill="#7E36F4"
		/>
		<path
			d="M18,12h0a.94.94,0,0,0-1-1H7a.94.94,0,0,0-1,1H6a.94.94,0,0,0,1,1H17A.94.94,0,0,0,18,12Z"
			fill="#7E36F4"
		/>
	</chakra.svg>
));

export const Buttons = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M19.27 12.91H4.73a1.83 1.83 0 0 0-1.82 1.82v5.45A1.83 1.83 0 0 0 4.73 22h14.54a1.83 1.83 0 0 0 1.82-1.82v-5.45a1.83 1.83 0 0 0-1.82-1.82Zm0 7.27H4.73v-5.45h14.54Z" />
		<path d="M7.45 18.36h9.1a.91.91 0 0 0 0-1.81h-9.1a.91.91 0 0 0 0 1.81ZM19.27 2H4.73a1.83 1.83 0 0 0-1.82 1.82v5.45a1.83 1.83 0 0 0 1.82 1.82h14.54a1.83 1.83 0 0 0 1.82-1.82V3.82A1.83 1.83 0 0 0 19.27 2Zm0 7.27H4.73V3.82h14.54Z" />
		<path d="M7.45 7.45h9.1a.85.85 0 0 0 .9-.9.85.85 0 0 0-.9-.91h-9.1a.85.85 0 0 0-.9.91.85.85 0 0 0 .9.9Z" />
	</chakra.svg>
));

export const Image = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M19.9 2.2H4.3c-1.2 0-2 .8-2 2v15.6c0 1.2.7 2.1 2 2.1h15.6c1.2 0 2-.8 2-2V4.3c-.1-1.3-.8-2.1-2-2.1zM4.3 19.8V4.2h15.6v15.6H4.3z" />
		<path d="M10.1 14l-1-1-3 4h12l-5-7-3 4z" />
	</chakra.svg>
));

export const CallToAction = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-4v-2h4V5H5v7h7.5v2H5a2 2 0 0 1-2-2V5Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M12.046 9.848a.699.699 0 0 1 .786.124l7.25 6.897a.703.703 0 0 1 .158.793.696.696 0 0 1-.692.413l-3.638-.292-2.085 3.045a.696.696 0 0 1-.753.28.703.703 0 0 1-.52-.617l-.897-9.95a.699.699 0 0 1 .392-.693Zm1.168 2.417.556 6.164 1.215-1.774a.696.696 0 0 1 .63-.301l2.072.166-4.473-4.255Z"
			clipRule="evenodd"
		/>
		<path d="M7 8.25c0 .45.333.75.833.75h8.334c.5 0 .833-.3.833-.75s-.333-.75-.833-.75H7.833c-.5 0-.833.375-.833.75Z" />
	</chakra.svg>
));

export const Progress = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M20 9.7H4a.3.3 0 0 0-.3.3v4a.3.3 0 0 0 .3.3h16a.3.3 0 0 0 .3-.3v-4a.3.3 0 0 0-.3-.3ZM4 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4Z"
			clipRule="evenodd"
		/>
		<path d="M3 9h7v6H3V9Z" />
	</chakra.svg>
));

export const Spacing = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			d="M21,2H3A1,1,0,0,0,2,3H2A.94.94,0,0,0,3,4H21a.94.94,0,0,0,1-1h0A.94.94,0,0,0,21,2Z"
			fill="#7E36F4"
		/>
		<path
			d="M2,21H2a.94.94,0,0,0,1,1H21a.94.94,0,0,0,1-1h0a.94.94,0,0,0-1-1H3A.94.94,0,0,0,2,21Z"
			fill="#7E36F4"
		/>
		<path
			d="M9,15V9A.94.94,0,0,0,8,8H8A1,1,0,0,0,7,9v6a.94.94,0,0,0,1,1H8A1,1,0,0,0,9,15Z"
			fill="#7E36F4"
		/>
		<path
			d="M17,15V9a.94.94,0,0,0-1-1h0a.94.94,0,0,0-1,1v6a.94.94,0,0,0,1,1h0A1.08,1.08,0,0,0,17,15Z"
			fill="#7E36F4"
		/>
		<path
			d="M13,17V7a.94.94,0,0,0-1-1h0a.94.94,0,0,0-1,1V17a.94.94,0,0,0,1,1h0A.94.94,0,0,0,13,17Z"
			fill="#7E36F4"
		/>
	</chakra.svg>
));

export const Team = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#7E36F4"
			fillRule="evenodd"
			// eslint-disable-next-line
			d="M6.81 14.425a4.077 4.077 0 0 1 2.882-1.194h4.616a4.077 4.077 0 0 1 4.076 4.077v1.538a1 1 0 0 1-2 0v-1.538a2.077 2.077 0 0 0-2.076-2.077H9.692a2.077 2.077 0 0 0-2.077 2.077v1.538a1 1 0 0 1-2 0v-1.538c0-1.082.43-2.119 1.194-2.883ZM12 6a2.077 2.077 0 1 0 0 4.154A2.077 2.077 0 0 0 12 6ZM7.923 8.077a4.077 4.077 0 1 1 8.154 0 4.077 4.077 0 0 1-8.154 0Zm10.801 5.903a1 1 0 0 1 1.218-.718A4.077 4.077 0 0 1 23 17.207v1.54a1 1 0 0 1-2 0v-1.539a2.077 2.077 0 0 0-1.558-2.009 1 1 0 0 1-.718-1.218Zm-2.308-9.228a1 1 0 0 1 1.217-.72 4.077 4.077 0 0 1 0 7.898 1 1 0 1 1-.496-1.937 2.077 2.077 0 0 0 0-4.024 1 1 0 0 1-.721-1.217ZM5.276 13.98a1 1 0 0 0-1.218-.718A4.078 4.078 0 0 0 1 17.207v1.54a1 1 0 0 0 2 0v-1.539A2.077 2.077 0 0 1 4.558 15.2a1 1 0 0 0 .718-1.218Zm2.308-9.228a1 1 0 0 0-1.217-.72 4.077 4.077 0 0 0 0 7.898 1 1 0 1 0 .496-1.937 2.077 2.077 0 0 1 0-4.024 1 1 0 0 0 .721-1.217Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const SocialShare = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		{/* eslint-disable-next-line */}
		<path d="M6 15c.9 0 1.7-.3 2.4-.9l6.3 3.6c-.1.3-.1.6-.1.9 0 1.9 1.6 3.5 3.5 3.6 1.9 0 3.5-1.6 3.6-3.5 0-1.9-1.6-3.5-3.5-3.6-.9 0-1.8.3-2.4.9l-6.3-3.6c.1-.2.1-.5.1-.8l6.1-3.5c1.4 1.3 3.6 1.2 4.9-.2 1.3-1.4 1.2-3.6-.2-4.9-1.4-1.3-3.6-1.2-4.9.2-.6.6-.9 1.5-.9 2.4 0 .3 0 .6.1.8L8.9 9.6c-1-1.6-3.2-2.1-4.8-1C2.5 9.7 2 11.8 3 13.4c.7 1 1.8 1.6 3 1.6Zm12 2c.8 0 1.5.7 1.5 1.5S18.8 20 18 20s-1.5-.7-1.5-1.5.6-1.5 1.5-1.5Zm0-13c.8 0 1.5.7 1.5 1.5S18.8 7 18 7s-1.5-.7-1.5-1.5S17.1 4 18 4ZM6 10c.8 0 1.5.7 1.5 1.5S6.8 13 6 13s-1.5-.7-1.5-1.5S5.1 10 6 10Z" />
	</chakra.svg>
));

export const Tabs = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fill="#7E36F4"
			fillRule="evenodd"
			d="M6 10V4H4v16h16V10H6Zm16-2v14H2V2h6v6h14Z"
			clipRule="evenodd"
		/>
		<path
			fill="#7E36F4"
			fillRule="evenodd"
			d="M13.5 3.5h-3v2h3v-2ZM9 2v5h6V2H9Zm11.5 1.5h-3v2h3v-2ZM16 2v5h6V2h-6Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Lottie = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M20 4v16H4V4h16m0-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM7 18a1 1 0 0 1 0-2c1.66 0 2.856-2.177 4.124-4.482C12.616 8.805 14.159 6 17 6a1 1 0 0 1 0 2c-1.66 0-2.856 2.177-4.124 4.482C11.384 15.195 9.841 18 7 18z" />
	</chakra.svg>
));

export const Testimonial = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M19.7 1.5H4.3c-1.2 0-2.2 1-2.2 2.2v12.9c0 1.2 1 2.2 2.2 2.2h3.9l3.8 3.7 3.8-3.7h3.9c1.2 0 2.2-1 2.2-2.2V3.7c0-1.2-1-2.2-2.2-2.2zm0 15.1h-4.9L12 19.4l-2.8-2.8H4.3V3.7h15.4v12.9z" />
		<circle cx="7.5" cy="10.1" r="1.5" />
		<circle cx="12" cy="10.1" r="1.5" />
		<circle cx="16.5" cy="10.1" r="1.5" />
	</chakra.svg>
));

export const Timeline = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M11 3a1 1 0 1 1 2 0v18a1 1 0 1 1-2 0V3Z" />
		<path
			fillRule="evenodd"
			d="M16.037 7.397 15 6.517l.953-.789c.262-.436.74-.728 1.286-.728H20.5a1.5 1.5 0 0 1 0 3h-3.261c-.492 0-.929-.237-1.202-.603Zm0 11L15 17.517l1.025-.898A1.498 1.498 0 0 1 17.239 16H20.5a1.5 1.5 0 0 1 0 3h-3.261c-.492 0-.929-.237-1.202-.603ZM8 12.847l1-.83-.966-.811A1.499 1.499 0 0 0 6.76 10.5H3.5a1.5 1.5 0 0 0 0 3h3.261c.514 0 .968-.259 1.238-.653Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const TableOfContents = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		{/* eslint-disable-next-line */}
		<path d="M16.8 9h-6.5c-.2 0-.3-.1-.3-.2V7.3c0-.2.1-.3.3-.3h6.5c.1 0 .2.1.2.3v1.5c0 .1-.1.2-.2.2zm-.8 3.8v-1.5c0-.1-.1-.3-.3-.3h-5.5c-.1 0-.3.1-.3.3v1.5c0 .1.1.3.3.3h5.5c.2-.1.3-.2.3-.3zm-2 4v-1.5c0-.1-.1-.3-.3-.3h-3.5c-.1 0-.3.1-.3.3v1.5c0 .1.1.3.3.3h3.5c.2-.1.3-.2.3-.3zm-5-8V7.3c0-.2-.1-.3-.2-.3H7.3c-.2 0-.3.1-.3.3v1.5c0 .1.1.2.3.2h1.5c.1 0 .2-.1.2-.2zm0 4v-1.5c0-.2-.1-.3-.2-.3H7.3c-.2 0-.3.1-.3.3v1.5c0 .1.1.2.3.2h1.5c.1 0 .2-.1.2-.2zm0 4v-1.5c0-.2-.1-.3-.2-.3H7.3c-.2 0-.3.1-.3.3v1.5c0 .1.1.2.3.2h1.5c.1 0 .2-.1.2-.2zm9 5.2H6c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h12c1.7 0 3 1.3 3 3v14c0 1.7-1.3 3-3 3zM6 4c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H6z" />
	</chakra.svg>
));

export const InfoBox = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M22 4V3c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V4zM4 4h16v16H4V4zm8 5.5a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 9.5zm3 1H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.5-1-1-1zm-4 8h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1 0 .5.4 1 1 1zm-5-4c0 .6.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .5-1 1z" />
	</chakra.svg>
));

export const Column = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M2 6h20v12H2z" fill="#7E36F4" />
		<path
			fill="#fff"
			d="M4 8h2.91v8H4zM8.36 8h2.91v8H8.36zM12.73 8h2.91v8h-2.91zM17.09 8H20v8h-2.91z"
		/>
	</chakra.svg>
));

export const Countdown = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		{/* eslint-disable-next-line */}
		<path d="m20.1 8.8.9-.9c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1 1c-1-.6-2.3-1-3.6-1-3.9 0-7 3.1-7 7.1 0 3.7 3.2 6.9 6.9 6.9 3.9 0 7.1-3.1 7.1-7 0-1.8-.7-3.4-1.9-4.7zM15 18.5c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c.6 0 1 .4 1 1v2c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-2c0-.6.4-1 1-1zm-1-7h2c.5 0 1 .4 1 1 0 .5-.4 1-1 1h-2c-.5 0-1-.4-1-1s.4-1 1-1zm-10 5h2c.5 0 1 .4 1 1 0 .5-.4 1-1 1H4c-.5 0-1-.4-1-1s.4-1 1-1zm0 8h2c.5 0 1 .4 1 1 0 .5-.4 1-1 1H4c-.5 0-1-.4-1-1s.4-1 1-1zm-1-4h2c.5 0 1 .4 1 1 0 .5-.4 1-1 1H3c-.5 0-1-.4-1-1s.4-1 1-1z" />
	</chakra.svg>
));

export const Counter = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		{/* eslint-disable-next-line */}
		<path d="M19.664 17.739V7.646l1.316 1.316a.575.575 0 0 0 .812-.811l-2.296-2.295a.573.573 0 0 0-.403-.169h-.005a.572.572 0 0 0-.406.169l-2.294 2.295a.573.573 0 1 0 .812.811l1.315-1.316v10.092a.574.574 0 0 0 1.149.001zm-15.64-.866a.58.58 0 0 1-.42-.16.527.527 0 0 1-.165-.396v-4.603l.128.201-.667.493a.502.502 0 0 1-.32.101.526.526 0 0 1-.383-.164.537.537 0 0 1-.165-.393c0-.195.094-.353.283-.475L3.63 10.6a.6.6 0 0 1 .206-.091.929.929 0 0 1 .214-.027.56.56 0 0 1 .42.16.548.548 0 0 1 .155.397v5.279c0 .158-.057.29-.169.396a.604.604 0 0 1-.432.159zm6.018-1.005a.496.496 0 0 1 .511.511.472.472 0 0 1-.146.352.502.502 0 0 1-.365.142H6.937a.493.493 0 0 1-.375-.146c-.091-.097-.137-.222-.137-.374s.055-.286.164-.401l1.991-2.129c.225-.242.403-.492.534-.748s.197-.478.197-.667c0-.304-.088-.549-.265-.735s-.411-.278-.703-.278a.86.86 0 0 0-.356.082 1.467 1.467 0 0 0-.352.228c-.113.098-.218.21-.315.338a.482.482 0 0 1-.219.183.547.547 0 0 1-.571-.113.459.459 0 0 1-.169-.352c0-.104.035-.204.105-.302a2.763 2.763 0 0 1 1.355-.972c.2-.064.396-.096.584-.096.408 0 .763.081 1.064.242s.534.39.699.685c.164.295.247.644.247 1.045 0 .335-.099.708-.297 1.119a4.647 4.647 0 0 1-.799 1.155l-1.233 1.315-.1-.083h2.056zm2.493-.283a.662.662 0 0 1 .393.137c.104.079.227.149.369.21.144.061.311.091.498.091.189 0 .367-.047.535-.142a1.138 1.138 0 0 0 .58-1.027c0-.23-.049-.423-.143-.575s-.219-.268-.375-.347a1.073 1.073 0 0 0-.496-.118c-.135 0-.246.012-.334.035-.088.025-.174.051-.256.078s-.178.041-.287.041a.389.389 0 0 1-.325-.146.546.546 0 0 1-.114-.346.51.51 0 0 1 .05-.229c.033-.067.083-.141.151-.22l1.607-1.708.246.21h-2.246a.496.496 0 0 1-.511-.511c0-.14.049-.257.146-.352a.502.502 0 0 1 .365-.142h2.795c.188 0 .33.052.424.155a.555.555 0 0 1 .143.393c0 .079-.021.157-.064.233s-.094.145-.154.206l-1.617 1.735-.246-.311c.066-.03.16-.058.277-.082a1.596 1.596 0 0 1 1.235.242c.264.186.469.426.611.721s.215.613.215.954c0 .451-.102.841-.303 1.169a1.966 1.966 0 0 1-.848.758c-.365.177-.793.266-1.279.266-.226 0-.447-.028-.667-.083a2.213 2.213 0 0 1-.566-.219.626.626 0 0 1-.27-.242.555.555 0 0 1-.068-.251c0-.14.05-.272.151-.397a.465.465 0 0 1 .378-.186z" />
	</chakra.svg>
));

export const Map = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z" />
		<path d="M11.42 21.814a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.005.021 4.438-4.388 8.423-6 9.73-1.611-1.308-6.021-5.294-6-9.735 0-3.309 2.691-6 6-6z" />
	</chakra.svg>
));

export const Notice = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			fillRule="evenodd"
			d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M12 7a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Paragraph = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			d="M9.15 17h2.3v4.1a.9.9 0 00.9.9.9.9 0 00.9-.9v-17h2.8v17a.9.9 0 00.9.9h.1a.9.9 0 00.9-.9v-17h3.1a.9.9 0 00.9-.9V3a.9.9 0 00-.9-.9h-12a7.2 7.2 0 00-7 7.5 7.2 7.2 0 007.1 7.4zm-.1-12.9h2.3V15h-2.2a5.79 5.79 0 01-5.1-5.5 5.69 5.69 0 015-5.45z"
			fill="#7E36F4"
		/>
	</chakra.svg>
));

export const Slide = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path d="M15 20.5H5c-1.654 0-3-1.346-3-3v-7c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v7c0 1.654-1.346 3-3 3zM5 9.5c-.551 0-1 .449-1 1v7c0 .552.449 1 1 1h10a1 1 0 0 0 1-1v-7c0-.551-.448-1-1-1H5zm17 5v-6c0-2.757-2.243-5-5-5H8.47a1 1 0 0 0 0 2H17c1.654 0 3 1.346 3 3v6a1 1 0 1 0 2 0z" />
	</chakra.svg>
));

export const Search = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M6.939 3.109a8 8 0 0 1 9.38 12.296l5.388 5.388a1 1 0 0 1-1.414 1.414l-5.388-5.387A8 8 0 1 1 6.94 3.109ZM10 4.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Trash = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		h={6}
		w={6}
		{...props}
		ref={ref}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M8.586 3.086A2 2 0 0 1 10 2.5h4a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-.08L19 19.546a3 3 0 0 1-3 2.954H8a3 3 0 0 1-3-2.954L4.08 8.5H4a1 1 0 0 1 0-2h4v-2a2 2 0 0 1 .586-1.414ZM6.086 8.5l.91 10.917A1 1 0 0 1 7 19.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 1 .003-.083l.91-10.917H6.087ZM14 6.5h-4v-2h4v2Zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));

export const Reset = forwardRef<IconProps, "svg">((props, ref) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			d="M6.228 8.5c1.63-2.365 4.61-3.523 7.515-2.778a7 7 0 1 1-8.685 7.689 1 1 0 0 0-1.983.26 9 9 0 1 0 11.166-9.886c-3.484-.894-7.074.35-9.241 3.02V4.5a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h.543a.93.93 0 0 0 .047 0H9a1 1 0 1 0 0-2H6.228Z"
			clipRule="evenodd"
		/>
	</chakra.svg>
));
